<template>
  <div class="bg-white p-4 border rounded shadow-sm">
    <div class="">
      <label class="block text-sm ">Venue name<span class="text-red-700">*</span></label>
      <input aria-label="Venue name" type="text" required v-model="name" :class="inputClass"
             placeholder="Venue name"/>
    </div>
    <div class="my-3">
      <label class="block text-sm leading-5 ">Address<span class="text-red-700">*</span></label>
      <input aria-label="Password" name="password" type="text" required v-model="address" :class="inputClass"
             placeholder="Address"/>
    </div>
    <div class="flex my-3 justify-between">
      <div class="w-full mr-2">
        <label class="block text-sm leading-5 ">Phone number</label>
        <input aria-label="Password" name="phone_number" type="text" v-model="phone_number" :class="inputClass"
               placeholder="Phone number"/>
      </div>
      <div class="w-full ml-2">
        <label class="block text-sm leading-5 ">Email</label>
        <input aria-label="Password" name="email" type="email" v-model="email" :class="inputClass"
               placeholder="Email"/>
      </div>
    </div>
    <div class="block md:flex my-3 justify-between">
      <div class="w-full md:mr-2">
        <label class="block text-sm leading-5 ">Success URL</label>
        <input type="text" required v-model="success_url" :class="inputClass"
               placeholder="https://"/>
      </div>
      <div class="w-full md:ml-2">
        <label class="block text-sm leading-5 ">Custom Splash URL</label>
        <input type="text" required v-model="custom_splash_url"
               :class="inputClass"
               placeholder="https://"/>
      </div>
    </div>
    <div class="my-3">
      <label class="block text-sm leading-5 ">Description</label>
      <textarea v-model="more_info" class="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900
                      rounded-b-md focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5"
                placeholder="Describe..."></textarea>
    </div>
    <div class="mt-6">
      <button v-if="$store.getters.can(venueId == null ?'create_networks':'edit_networks')" type="submit" v-on:click="updateOrCreateVenue" class="rounded px-4 md:px-5 xl:px-4 py-2  bg-teal-500 hover:bg-teal-600 md:text-lg leading-tight
                       xl:text-base text-white">
        {{ venueId == null ? "Create" : "Update" }}
      </button>
    </div>
  </div>
</template>

<script>
import Utils from "../services/Utils";

export default {
  name: "UpdateOrCreateVenueComponent",
  props: {
    venueId: String
  },
  data() {
    return {
      venue: null,
      name: null,
      phone_number: null,
      address: null,
      email: null,
      custom_splash_url: null,
      success_url: null,
      more_info: null,
      loading: false,
      errors: [],
      inputClass: 'appearance-none block w-full text-gray-700 border border-gray-300 rounded py-2 px-4 leading-tight focus:outline-none focus:border-gray-500'
    }
  },
  mounted() {
    if (this.venueId != null)
      this.getVenue()
  },
  watch: {
    venue: function (venue) {
      this.name = venue.name;
      this.address = venue.address;
      this.email = venue.email;
      this.phone_number = venue.phone_number;
      this.custom_splash_url = venue.custom_splash_url;
      this.success_url = venue.success_url;
      this.more_info = venue.more_info;
      this.lat = venue.lat;
      this.lng = venue.lng;
    },
    errors: function (errors) {
      this.$root.$emit('alert_error', errors);
    }
  },
  methods: {
    getVenue() {
      this.axios.get(process.env.VUE_APP_SERVER_URL + '/api/v1/venues/' + this.venueId)
          .then((result) => {
            this.venue = result.data.data.venue;
          })
          .catch(() => {
            this.errors.push("An error occurred while connecting to server")
          }).finally(() => {
      });
    },

    updateOrCreateVenue() {
      this.loading = true;
      this.errors = [];
      if (this.name == null || this.name === '')
        this.errors.push("Name field is required.");
      if (this.address == null || this.address === '')
        this.errors.push("Address field is required.");
      if (this.errors.length > 0) {
        this.loading = false;
        return;
      }

      let params = {
        name: this.name,
        address: this.address,
        phone_number: this.phone_number,
        email: this.email,
        custom_splash_url: this.custom_splash_url,
        success_url: this.success_url,
        more_info: this.more_info,
        organization_id: this.$store.getters.orgId
      };

      let request = this.venueId == null ? this.axios.post(process.env.VUE_APP_SERVER_URL + '/api/v1/venues', params) :
          this.axios.put(process.env.VUE_APP_SERVER_URL + '/api/v1/venues/' + this.venueId, params)

      request.then((result) => {
        this.$root.$emit('alert_success', [result.data.data.message]);
        this.$root.$emit(this.venueId == null ? "venue_created" : "refresh_venue", true)
        this.venue = result.data.data.venue;
      }).catch((error) => {
        if (error.response != null && error.response.status === 422)
          this.errors = Utils.processError(error.response.data);
        else
          this.errors.push("An error occurred while connecting to server")
      }).finally(() => {
        this.loading = false;
      });
    }
  }
}
</script>

<style scoped>

</style>